import { render, staticRenderFns } from "./ApprovalDashboard.vue?vue&type=template&id=21131a2c&"
import script from "./ApprovalDashboard.vue?vue&type=script&lang=js&"
export * from "./ApprovalDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports